import type { MeshStandardMaterial, Texture } from 'three'
import { applyTextureQuality } from '@utils/sceneObjects/textureCache'

/** Roughness mínima en telas: mate pero con micro-brillo que revele la trama. */
export const FABRIC_MIN_ROUGHNESS = 0.68 as const
export const FABRIC_MIN_BUMP_SCALE = 0.22 as const
/** Reflejo ambiental mínimo: da volumen sin aspecto plástico. */
export const FABRIC_MIN_ENV_MAP_INTENSITY = 0.18 as const

export function resolveFabricRoughness(roughness: number): number {
  if (!Number.isFinite(roughness)) return FABRIC_MIN_ROUGHNESS
  return Math.max(roughness, FABRIC_MIN_ROUGHNESS)
}

export function resolveFabricEnvMapIntensity(envMapIntensity: number): number {
  if (!Number.isFinite(envMapIntensity)) return FABRIC_MIN_ENV_MAP_INTENSITY
  return Math.max(envMapIntensity, FABRIC_MIN_ENV_MAP_INTENSITY)
}

export function resolveFabricBumpScale(bumpScale: number, hasDetailMap: boolean): number {
  if (!hasDetailMap) return bumpScale
  if (!Number.isFinite(bumpScale) || bumpScale <= 0) return FABRIC_MIN_BUMP_SCALE
  return Math.max(bumpScale, FABRIC_MIN_BUMP_SCALE)
}

export function configureFabricDiffuseSampling({
  texture,
  material,
}: {
  texture: Texture
  material?: MeshStandardMaterial
  baseRepeat?: { x: number; y: number }
  itemId?: string
}): void {
  applyTextureQuality(texture)
  if (material) {
    material.roughness = resolveFabricRoughness(material.roughness)
    material.envMapIntensity = resolveFabricEnvMapIntensity(material.envMapIntensity)
    material.needsUpdate = true
  }
}
